<script>
    import { sgettext } from '../../../i18n.js';
  
    export let activeComponent;
  
    let navItems = [
      {
        id: 'reviewSummary',
        iconPath: 'M9.25 0.25H1.75C0.925 0.25 0.2575 0.925 0.2575 1.75L0.25 12.25C0.25 13.075 0.9175 13.75 1.7425 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V4.75L9.25 0.25ZM1.75 12.25V1.75H8.5V5.5H12.25V12.25H1.75ZM4.75 4C4.75 4.4125 4.4125 4.75 4 4.75C3.5875 4.75 3.25 4.4125 3.25 4C3.25 3.5875 3.5875 3.25 4 3.25C4.4125 3.25 4.75 3.5875 4.75 4ZM4.75 7C4.75 7.4125 4.4125 7.75 4 7.75C3.5875 7.75 3.25 7.4125 3.25 7C3.25 6.5875 3.5875 6.25 4 6.25C4.4125 6.25 4.75 6.5875 4.75 7ZM4.75 10C4.75 10.4125 4.4125 10.75 4 10.75C3.5875 10.75 3.25 10.4125 3.25 10C3.25 9.5875 3.5875 9.25 4 9.25C4.4125 9.25 4.75 9.5875 4.75 10Z',
        label: sgettext('$$REVIEW_SUMMARY$$'),
        tooltip: sgettext('$$SUMMARY_WORKFLOW_PROGRESS_COMMENTS$$'),
        widthAndHeight: '14',
        viewBox: '0 0 14 14',
      },
      {
        id: 'riskRating',
        iconPath: 'M10.875 2.625C10.875 3.75 9.75 7.125 9.75 7.125H8.25C8.25 7.125 7.125 3.75 7.125 2.625C7.125 1.59 7.965 0.75 9 0.75C10.035 0.75 10.875 1.59 10.875 2.625ZM9 8.25C8.175 8.25 7.5 8.925 7.5 9.75C7.5 10.575 8.175 11.25 9 11.25C9.825 11.25 10.5 10.575 10.5 9.75C10.5 8.925 9.825 8.25 9 8.25ZM12.06 4.5825C12.195 4.02 12.3075 3.48 12.3525 3.0375C14.8125 4.2675 16.5 6.81 16.5 9.75C16.5 13.89 13.14 17.25 9 17.25C4.86 17.25 1.5 13.89 1.5 9.75C1.5 6.81 3.1875 4.2675 5.6475 3.0375C5.7 3.48 5.805 4.0275 5.94 4.5825C4.185 5.6325 3 7.5525 3 9.75C3 13.065 5.685 15.75 9 15.75C12.315 15.75 15 13.065 15 9.75C15 7.5525 13.815 5.6325 12.06 4.5825ZM13.5 9.75C13.5 12.2325 11.4825 14.25 9 14.25C6.5175 14.25 4.5 12.2325 4.5 9.75C4.5 8.25 5.235 6.9225 6.36 6.105C6.5325 6.7125 6.8475 7.6575 6.8475 7.6575C6.3225 8.1975 6 8.94 6 9.75C6 11.4075 7.3425 12.75 9 12.75C10.6575 12.75 12 11.4075 12 9.75C12 8.94 11.6775 8.1975 11.1525 7.6575C11.1525 7.6575 11.46 6.7425 11.64 6.105C12.765 6.9225 13.5 8.25 13.5 9.75Z',
        label: sgettext('$$RISK_RATING$$'),
        tooltip: sgettext('$$DISPLAYS_RESIDUAL_RISK_RATINGS_ELEMENTS$$'),
        widthAndHeight: '16',
        viewBox: '0 0 18 18',
      },
      {
        id: 'materialRisk',
        iconPath: 'M9 1.5L3 3.75V8.3175C3 12.105 5.5575 15.6375 9 16.5C12.4425 15.6375 15 12.105 15 8.3175V3.75L9 1.5ZM13.5 8.3175C13.5 11.3175 11.5875 14.0925 9 14.94C6.4125 14.0925 4.5 11.325 4.5 8.3175V4.7325L9 3.1425L13.5 4.7325V8.3175ZM6.615 7.9425L5.55 9L8.205 11.655L12.45 7.41L11.3925 6.3525L8.2125 9.5325L6.615 7.9425Z',
        label: sgettext('$$MATERIAL_RISK$$'),
        tooltip: sgettext('$$DISPLAYS_SAFETY_ELEMENTS_ACTIVITY_OWNERS$$'),
        widthAndHeight: '18',
        viewBox: '0 0 18 18',
      }
    ];
</script>

<div class="sticky-header">
  <ul class="button-group">
    {#each navItems as item}
      <li class="nav-item">
        <a
          class="nav-link"
          class:active={activeComponent === item.id}
          on:click={() => (activeComponent = item.id)}
          href="#{item.id}"
          title={item.tooltip}
        >
          <svg
            class="nav-icon"
            width={item.widthAndHeight}
            height={item.widthAndHeight}
            viewBox={item.viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
          >
            <path d={item.iconPath} />
          </svg>
          {item.label}
        </a>
      </li>
    {/each}
  </ul>
  <div class="horizontal-line" />
</div>

<style>
  .sticky-header {
    display: flex;
    flex-direction: column;
    position: relative;
    top: 0;
    background: white;
    padding-top: 0.9rem;
    padding-bottom: 0.9rem;
  }

  .button-group {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0 0 0.9rem 0;
  }

  .horizontal-line {
    height: 1px;
    background-color: lightgrey;
  }

  .nav-item {
    margin-right: 10px;
  }

  .nav-link {
    text-decoration: none;
    background-color: transparent;
    color: grey;
    transition: background-color 0.3s, color 0.3s;
    display: flex;
    align-items: center;
    padding: 5px 10px;
  }

  .nav-link:hover {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .nav-link.active {
    color: #df5900;
    font-weight: 700;
  }

  .nav-icon {
    margin-right: 6px;
  }
</style>
